import type { Variants } from "framer-motion";
import {
  DURATION_FAST,
  DURATION_NORMAL,
  DURATION_SLOW,
  EASE_SMOOTH,
  REVEAL_OFFSET_Y,
  STAGGER_CHILDREN,
  STAGGER_DELAY,
} from "@/components/motion/constants";

export function getRevealVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.2 } },
    };
  }

  return {
    hidden: { opacity: 0, y: REVEAL_OFFSET_Y },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION_NORMAL, ease: EASE_SMOOTH },
    },
  };
}

export function getStaggerContainerVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: {},
      visible: { transition: { staggerChildren: 0 } },
    };
  }

  return {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: STAGGER_CHILDREN,
        delayChildren: STAGGER_DELAY,
      },
    },
  };
}

export function getStaggerItemVariants(reduced: boolean | null): Variants {
  return getRevealVariants(reduced);
}

export function getHeroContainerVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: {},
      visible: { transition: { staggerChildren: 0 } },
    };
  }

  return {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.14, delayChildren: 0.15 },
    },
  };
}

export function getHeroLineVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.2 } },
    };
  }

  return {
    hidden: { opacity: 0, y: "100%" },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION_SLOW, ease: EASE_SMOOTH },
    },
  };
}

export function getHeroItemVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.2 } },
    };
  }

  return {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION_NORMAL, ease: EASE_SMOOTH },
    },
  };
}

export function getFadeVariants(reduced: boolean | null): Variants {
  if (reduced) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.15 } },
    };
  }

  return {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: DURATION_FAST, ease: EASE_SMOOTH },
    },
  };
}
